import axios from 'axios';

export default {
  keepAlive() {
    return axios.post('/fcgi-bin/system.session-keep-alive?alive=true');
  },
};
